module.exports = __webpack_public_path__ + "img/rz2.2851c797.png";